import { render, staticRenderFns } from "./MenuEditorSidebar.vue?vue&type=template&id=633b3321"
import script from "./MenuEditorSidebar.vue?vue&type=script&lang=js"
export * from "./MenuEditorSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports